<div mat-dialog-content style="padding-bottom: 20px;">
  <h4 mat-dialog-title>{{title}}</h4>
  <h5 mat-dialog-title>{{subtitle}}</h5>
  <hr><br>
  <strong>Rationale</strong><br><br>

  Le malattie infiammatorie croniche intestinali (IBD), malattia di Crohn (CD) e colite ulcerosa (UC),
  sono patologie croniche a decorso invalidante ma non fatale, caratterizzate da più elevata incidenza
  tra i 15 ed i 45 anni di età, con una prevalenza all’incirca di 100/200 casi su 100.000 abitanti,
  corrispondenti a circa 10.000 soggetti affetti sul territorio Piemontese. Il decorso di malattia è
  classicamente remittente-intermittente, con alternanze di periodi di remissione clinica più o meno
  estesi e di periodi di esacerbazione di varia gravità. Le IBD determinano con il loro decorso un
  effetto invalidante su diverse dimensioni: fisica, psicologica, sociale e lavorativa.
  La gestione di queste patologie richiede diversi livelli assistenziali e personalizzazione dell’algoritmo
  gestionale. Dal punto di vista della struttura erogante il servizio assistenziale richiede rapidità di
  accesso a visite ambulatoriali ed esami endoscopici ed ecografici, integrazione tra Centri di I livello
  e Centri di riferimento per i casi più complessi, e possibilità di procedere ai diversi livelli di assistenza:
  visite ambulatoriali, assistenza domiciliare, Day Hospital e degenza breve/ordinaria, nonché, in casi
  ulteriormente selezionati, assistenza sub-intensiva o collaborazione chirurgica. Dal punto di vista dei
  pazienti la variabilità dei sintomi richiede pronto riconoscimento e tempestivi interventi, per limitare
  il rischio di recrudescenze che, sotto trattate, possano arrivare a richiedere poi ricoveri e maggiori
  intensità di terapia.
  Per "eHealth", o "Sanità in Rete" s'intende l'utilizzo di strumenti basati sulle tecnologie
  dell'informazione e della comunicazione per sostenere e promuovere la prevenzione, la diagnosi, il
  trattamento e il monitoraggio delle malattie e la gestione della salute e dello stile di vita.
  L’applicazione di metodiche di eHealth basate su questionari clinici e/o raccolta di dati biometrici è
  stata studiata per consentire una migliore gestione dei pazienti affetti da svariate malattie.
  L’esperienza internazionale in tale ambito suggerisce che la telemedicina, attraverso un’interfaccia
  web, ha permesso di contribuire alla gestione diretta da parte dei pazienti delle proprie
  problematiche, ma anche di giungere a un risparmio nell’utilizzo di risorse sanitarie, principalmente
  legato a un minor numero di visite ambulatoriali ed anche nel campo delle IBD, ma tutt’oggi in
  Italia non esiste alcuna esperienza in tale campo. <br><br>

  <strong>Obiettivo dello studio</strong><br><br>

  <strong>Analizzare l’utilità del’uso di questionari rispetto alla capacità di misurare situazioni di
    miglioramento o peggioramento clinico. Obiettivo secondario è creare e validare un attendibile
    algoritmo per il riferimento ai livelli di cura superiori dei casi con peggioramento clinico (visite,
    ricoveri, ecc.) e di verificarne l’efficienza attraverso il confronto della performance della
    gestione standard of care</strong><br><br>

  <strong>Come si svolge e cosa le è richiesto</strong><br><br>

  Il protocollo di studio prevede che i pazienti affetti da IBD afferenti alla AO Ordine Mauriziano
  vengano invitati a partecipare al programma di eHealth, attraverso gli accessi in mobile (App) e/o
  sito web. Lei sarà dotato di un sistema che permetterà di registrare i parametri clinici essenziali
  (clinimetria) secondo score validati per l'utilizzo autonomo ed a distanza da parte dei pazienti,
  utilizzando questionari validati per approfondire periodicamente aspetti della sua qualità della vita,
  capacità lavorativa/disabilità da malattia, aderenza e timori per i trattamenti, misura dello stress e
  dell’ansia.
  Al momento del primo accesso alla piattaforma le verrà chiesto il consenso a partecipare allo studio,
  un contatto email utilizzabile per eventuali necessità, e verrà attribuito in maniera casuale
  (randomizzato) dal sistema a uno dei 3 gruppi di valutazione:
  - monitoraggio con sistema di telemedicina
  - monitoraggio tradizionale
  - opzione di scegliere liberamente il sistema di monitoraggio preferito tra telemedicina e
  sistema tradizionale
  Con tempistiche differenti le verranno proposti dei qustionari che dsaranno controllati dai clinici
  presso il Centro dell’AO Ordine Mauriziano. Se sarà seguito con il programma di telemedicina,
  qualora la sua situazione clinica si mantenga all'interno dell'algoritmo preimpostato, il medico
  non
  dovrà intervenire, mentre in caso di scostamenti (comportamento outlier), sarà contattato
  tempestivamente dal Centro per una valutazione clinica tempestiva e per maggiori azioni correttive.
  Per coloro che saranno seguiti in maniera ‘tradizionale’, vi sarà l’usuale pratica di visite programmate
  ed il paziente potrà accedere a controlli anticipati ricontattando il Centro con le usuali modalità
  (contatto email o telefonico per comunicare attivamente l’intercorsa problematica).
  L’appartenenza a uno o all’altro gruppo di valutazione non condizionerà le scelte terapeutiche o la
  facilità di accedere ai controlli.
  I suoi dati sensibili saranno salvati su una piattaforma web-based e gestiti con crittografia e secondo
  i più elevati standard per la salvaguardia della privacy e l’integrità dei dati. Al termine dello studio i
  dati sensibili verranno eliminati. <br><br>

  <strong>Che cosa avviene se sceglie di non partecipare allo Studio</strong><br><br>

  La partecipazione allo studio è del tutto volontaria, non è prevista alcuna forma di compenso
  monetario per la sua partecipazione. Lo studio non prevede la somministrazione di farmaci o
  vaccini, né alcun intervento su di lei. È suo diritto in qualsiasi momento revocare il consenso allo
  studio e/o richiedere l’eliminazione dei dati raccolti nell’ambito di questo studio clinico.
  Chiaramente può decidere di non prestare il suo consenso allo studio, senza che questo influisca con
  la sua esperienza nell’AO Ordine Mauriziano di Torino.
  A sua ulteriore garanzia, inoltre, vi è il fatto che lo studio sia stato valutato e approvato nella sua
  attuale forma dal Comitato Etico Interaziendale A.O.U. Città della Salute e della Scienza di Torino -
  A.O. Ordine Mauriziano - A.S.L. Città di Torino (Presidio Ospedaliero Molinette - Padiglione beige
  – 3°Piano (ex Casa Suore) - Corso Bramante 88; 10126 Torino - Tel. 011.633.6547-5076-7231; Email:
  - comitatoetico@cittadellasalute.to.it - gdisipio@cittadellasalute.to.it). <br><br>

  <strong>Servizi di telecomunicazione</strong><br><br>

  <strong>Polito (Politecnico di Torino) ed Fondazione LINKS hanno sviluppato</strong> un sistema di assistenza
  remoto ed elettronico (IBDeHealth) specificamente per telemedicina.

  <strong>Sistema di erogazione dei servizi (piattaforma) </strong><br><br>

  Il contributo dell’attività <strong>della Fondazione LINKS</strong> è diretto alla definizione di una piattaforma
  (tecnologica e di servizio) programmabile per sistemi di cura personalizzata. La piattaforma si baserà
  su dispositivi mobili di uso comune come Personal Computer, Tablet e Smartphone e sfrutterà le
  funzioni avanzate dei più recenti sistemi di comunicazione senza fili, di comunicazione multimediale
  e di interfacce per l’acquisizione dei dati dei sensori clinici.
  La piattaforma sarà sviluppata per essere in grado di interagire, attraverso la rete, con un’architettura
  informativa di storicizzazione, analisi ed instradamento delle informazioni al personale addetto all'
  assistenza e cura
  Nel percorsi di cura sarà considerata della gravità del caso, e la terapia verrà pianificata sulla specifica
  scheda personale della persona assistita. <br><br>

  <strong>Dati a terzi per scopi di pubblicazione scientifica: </strong><br><br>

  I promotori si impegnano alla pubblicazione rigorosa dei risultati dello studio in ogni caso, su
  rivista peer-reviewed internazionale.
  Nessun dato personale tra i seguenti: nome, cognome, indirizzo, numero di telefono, sarà condiviso
  con altri partner del progetto o con qualsiasi altra entità al di fuori dello studio stesso.
  I restanti dati verranno elaborati in modo separato e anonimo (in modo che sia impossibile
  collegarlo alla sua persona), ed i dati verranno pubblicati in forma aggregata. <br><br>

  <strong>INFORMAZIONI SUL TRATTAMENTO DEI DATI PERSONALI E MANIFESTAZIONE
    DEL CONSENSO
    (ai sensi dell'art. 13 del Regolamento UE 2016/679) </strong><br><br>

  <strong>SPERIMENTAZIONI CLINICHE</strong><br><br>

  Ai sensi del Regolamento UE 2016/679 General Data Protection Regulation (GDPR) relativo alla
  protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera
  circolazione di tali dati (in seguito GDPR EU 2016/679), l'Azienda Ospedaliera Ordine Mauriziano
  di Torino (in seguito anche solo “Azienda”), in qualità di Titolare del trattamento, La informa che i
  Suoi dati saranno trattati nell'ambito delle sperimentazioni cliniche, secondo le modalità di seguito
  riportate. <br><br>

  <strong>TITOLARE DEL TRATTAMENTO</strong> (soggetto che, ai sensi del regolamento privacy europeo,
  definisce finalità e strumenti del trattamento) è l’Azienda, come Promotore, ex D.M. 17.12.04, dello
  Studio che le è stato descritto. <strong>Il Titolare del trattamento è pertanto l'Azienda Ospedaliera
  Ordine Mauriziano di Torino con sede in Torino, Via Magellano 1. </strong><br><br>

  <strong>FINALITA' DEL TRATTAMENTO DEI DATI</strong><br><br>

  Il presente trattamento, avente a oggetto i Suoi dati personali (qualsiasi informazione relativa alla
  persona fisica, ivi compreso un numero di identificazione personale) e quelli relativi allo stato di
  salute, verrà effettuato per finalità di <strong>ricerca scientifica effettuata sulla base di un progetto</strong>,
  oggetto di motivato parere favorevole del competente comitato etico a livello territoriale, secondo
  le modalità previste dalla legge vigente. <br><br>

  <strong>BASE GIURIDICA DEL TRATTAMENTO DEI DATI PERSONALI</strong><br><br>

  La partecipazione alla sperimentazione avviene su base volontaria, libera e consapevole.
  La Sua partecipazione al progetto è importante perché offre un aiuto per il miglioramento delle cure
  sanitarie o per l’avanzamento della ricerca scientifica e, aumentando il bagaglio delle conoscenze
  disponibili, per il progresso della società.
  <strong>Il mancato consenso al trattamento dei dati per tale finalità non pregiudica, in ogni caso, il
    Suo diritto di avvalersi delle altre prestazioni medico sanitarie erogate dall'Azienda, né avrà
    alcuna incidenza sulla qualità delle relazioni con lo staff sanitario che L’ha in cura e con il
    medico sperimentatore. </strong>
  Premesso ciò, il trattamento verrà eseguito sulla base dei presupposti di legittimità di seguito elencati,
  per ciascuna delle finalità di cui sopra:
  - Il Suo <strong>consenso esplicito</strong>, che liberamente può prestare e revocare in ogni momento;
  l'eventuale revoca avrà valore solo per il futuro, restando valido il trattamento eseguito fino a
  quel momento;
  - necessità di adempiere ad un obbligo giuridico e motivi di rilevante interesse pubblico;
  - necessità di perseguire la finalità, in misura proporzionata ad essa, nel rispetto dell’essenza
  del diritto alla protezione dei dati e con previsione di misure appropriate e specifiche a Sua
  tutela. <br><br>

  <strong>NATURA DEI DATI TRATTATI</strong><br><br>

  Verranno trattati alcuni suoi dati personali “comuni” (quali nome e cognome, numero di telefono,
  indirizzo e-mail), e dati relativi alla Sua salute; in base alle finalità della ricerca e alle caratteristiche
  dello studio, il protocollo può prevedere che i medici raccolgano informazioni ulteriori rispetto ai
  dati medico/clinici a Lei riferiti, quali dati di carattere demografico (data di nascita o età, sesso,
  origine etnica, peso e statura) o relativi alla Sua storia medica, agli stili di vita o alla vita sessuale. <br><br>

  <strong>MODALITA' DEL TRATTAMENTO</strong><br><br>

  Le operazioni di raccolta, registrazione, conservazione e modificazione dei dati personali
  avverranno attraverso strumenti manuali e informatici con logiche strettamente correlate alle
  finalità sopra indicate.
  I dati sono salvati in un centro di raccolta residente in <strong>Belgio (UE) </strong> e verranno trattati con modalità
  atte a garantire la riservatezza e la sicurezza delle informazioni, ai sensi degli artt. 25 e 32 del
  GDPR. Nell’ipotesi in cui venga fatto uso, per eseguire il trattamento, di soluzioni tecnologiche
  avanzate (es. analisi di big data, algoritmi di “intelligenza artificiale”, ecc.) ne verrà data opportuna
  evidenza.
  Tutte le operazioni in materia, effettuate solo da personale debitamente istruito e autorizzato dal
  Titolare o suo delegato, avverranno nel rispetto del segreto professionale, del segreto d'ufficio e
  dei principi di correttezza, liceità e trasparenza, secondo quanto disposto dalla normativa vigente.
  Il medico che La seguirà nello studio, i cui contatti Le saranno indicati nel seguito di questa
  Informativa, La identificherà con un codice realizzato con modalità atte a garantire la riservatezza
  e la sicurezza delle informazioni (la relativa documentazione di riferimento che consente di
  associare ai codici i dati nominativi dei pazienti verrà conservata e custodita dallo sperimentatore,
  separatamente dai restanti documenti di studio, e sarà accessibile solo a soggetti specificatamente
  da lui autorizzati).
  I dati che La riguardano raccolti nel corso dello studio, a eccezione del Suo nominativo, saranno
  registrati, elaborati e conservati unitamente a tale codice. Soltanto il medico e i soggetti autorizzati
  potranno collegare questo codice al Suo nominativo. <br><br>

  <strong>CATEGORIE DI SOGGETTI CUI I DATI POSSONO ESSERE COMUNICATI</strong><br><br>

  Tutte le operazioni di trattamento, effettuate solo da personale debitamente istruito ed autorizzato
  (quali il Data Manager che presta la sua attività per il Centro Sperimentatore e si occupa, ad
  esempio, della compilazione dei documenti e della raccolta dei report) dal Titolare o suoi delegati,
  avverranno nel rispetto del segreto professionale, del segreto d'ufficio e dei principi di correttezza,
  liceità e trasparenza, secondo quanto disposto dalle normative vigenti.
  E’ cura dei centri di sperimentazione garantire che il personale coinvolto nelle sperimentazioni
  cliniche e, in particolare, nei colloqui preliminari volti all’acquisizione del consenso informato, sia
  formato adeguatamente anche sugli aspetti rilevanti della disciplina sulla protezione dei dati
  personali,
  La Sua partecipazione allo studio implica che, in conformità alla normativa sulle sperimentazioni
  cliniche dei medicinali, il Comitato Etico e le autorità sanitarie italiane potranno conoscere i dati
  che La riguardano, contenuti anche nella Sua documentazione clinica originale, con modalità tali
  da garantire la riservatezza della Sua identità.
  I dati che emergeranno dai risultati delle analisi, qualora comportino un beneficio concreto e diretto
  in termini di terapia, prevenzione o di consapevolezza delle Sue scelte future, saranno resi noti
  direttamente a Lei, e solamente con il Suo consenso potranno essere resi noti a persone diverse, da
  Lei specificamente indicate.
  I Suoi dati potranno essere trattati con la collaborazione di soggetti “Responsabili del Trattamento”
  e che hanno siglato il relativo accordo a nomina responsabile esterno nel rispetto delle disposizioni
  dell'art.28 del GDPR. L’interessato ha diritto di richiedere l’indicazione del/dei responsabile/i
  scrivendo al Titolare del trattamento (dati di contatto di cui alla prima pagina). <br><br>

  <strong>DIFFUSIONE DEI DATI E TRASFERIMENTO DEI DATI PERSONALI EXTRA UE</strong><br><br>

  I Suoi dati personali non saranno diffusi se non in forma aggregata e, quindi, in modo
  assolutamente anonimo.
  Per quanto concerne l’eventuale trasferimento dei Dati verso Paesi Terzi, il Titolare rende noto che
  il trasferimento avverrà nel rispetto degli artt. 44 e ss. ss. del GDPR (Trasferimento sulla base di una
  decisione di adeguatezza, trasferimento soggetto a garanzie adeguate) con esclusione dell'art. 49 a
  oggetto “Deroghe in specifiche situazioni”.
  Maggiori informazioni sono disponibili presso il Titolare o presso il DPO scrivendo agli indirizzi
  sopraindicati. <br><br>

  <strong>PERIODO DI CONSERVAZIONE DEI DATI PERSONALI</strong><br><br>

  I Suoi dati Personali saranno conservati solo per il tempo necessario al perseguimento delle finalità
  per cui sono stati raccolti e trattati, fatto salvo il maggior tempo necessario per adempiere a obblighi
  di conservazione cui il Titolare è tenuto in ragione della natura del dato o del documento o per
  motivi di interesse pubblico o in esecuzione di specifici obblighi di legge (ai sensi del D.M.
  15.07.1997; D. Lgs. n. 219/2006; D. Lgs. n. 200/2007; “Linee guida per i trattamenti di dati
  personali nell’ambito delle sperimentazioni cliniche di medicinali” del 24 Luglio 2008 del Garante
  per la protezione dei dati personali e ss.mm.ii.). <br><br>

  <strong>DIRITTI DELL'INTERESSATO</strong><br><br>

  In relazione al trattamento dei dati personali che la riguardano, il Capo III del Regolamento UE
  2016/679 Le riconosce specifici diritti e, in particolare, il diritto, se applicabile, di:<br>
  A. accedere ai Suoi dati personali e alle informazioni relative agli stessi; <br>
  B. chiedere l’aggiornamento, la rettifica dei dati inesatti e l’integrazione di quelli incompleti; <br>
  C. chiedere la cancellazione dei dati personali che La riguardano al verificarsi di una delle
  condizioni indicate all’art. 17, paragrafo 1 del GDPR e nel rispetto delle eccezioni previste
  al paragrafo 3 del medesimo articolo e purché non sussistano obblighi di conservazione del
  dato previsti dalla legge; <br>
  D. chiedere la limitazione del trattamento dei Suoi dati al ricorrere di una delle ipotesi previste
  dall’art. 18 del GDPR; <br>
  E. chiederne la trasmissione dei Suoi dati ad altro Titolare in formato leggibile con le più
  comuni applicazioni informatiche (cd. “diritto alla portabilità”), ove tecnicamente possibile; <br>
  F. opporsi in qualunque momento al trattamento dei Suoi dati personali al ricorrere di
  situazioni particolari che La riguardano; <br>
  G. revocare il consenso in qualsiasi momento, limitatamente alle ipotesi in cui il trattamento
  sia basato sul Suo consenso per una o più specifiche finalità e riguardi dati personali comuni
  oppure particolari categorie di dati. Il trattamento basato sul consenso, ed effettuato
  antecedentemente alla revoca dello stesso, conserva, comunque, la sua liceità; <br>
  H. presentare reclamo all’Autorità Garante per la Protezione dei Dati Personali (i cui recapiti
  sono rinvenibili sul sito www.garanteprivacy.it) in caso di illecito trattamento o di ritardo
  nella risposta del Titolare a una richiesta inerente nei Suoi diritti; <br>
  <strong>I. interrompere in ogni momento e senza fornire alcuna giustificazione la Sua
    partecipazione allo studio: in tal caso, tutti i dati a Lei correlati verranno distrutti.
    Non saranno raccolti, inoltre, ulteriori dati che La riguardano. </strong><br>
  Se ha domande o dubbi sulla ricerca, non esiti a contattare i Promotori per qualsiasi chiarimento che
  si dovesse rendere necessario, in particolare potrà contattare il Dr. Marco Daperno, SC
  Gastroenterologia, tramite email (mdaperno@gmail.com) o al numero interno 2534 o 2914.
  I Promotori dello studio:
  Dr. Rodolfo Rocca (SC Gastroenterologia, rrocca@mauriziano.it , Sperimentatore Principale)
  Dr. Marco Daperno (SC Gastroenterologia, mdaperno@gmail.com , Co-sperimentatore)
  Dr. Ing. Guido Pagana (Politecnico di Torino, guido.pagana@linksfoundation.com , Cosperimentatore)
  Procedendo oltre dichiaro di aver avuto tempo per comprendere lo studio clinico oggetto di questa
  informativa, quanto mi è richiesto e di aver avuto l'opportunità di chiarire eventuali dubbi o
  preoccupazioni sulla ricerca. Ho capito che potrei decidere di accettare di partecipare o meno senza
  alcuna penalità. Confermo di aver letto e compreso le informazioni sulla ricerca e accetto di
  partecipare allo studio.
  Procedendo cliccando il tasto <strong>Acconsento</strong> dichiaro di aver compreso le finalità e le modalità dello
  studio e di acconsentire alla partecipazione allo studio, e di voler procedere alla compilazione del
  questionario specifico ed al prelievo ematico previsti dallo studio.
  Cliccando il tasto <strong>Non acconsento</strong> dichiaro di non voler partecipare allo studio clinico, la mia
  collaborazione si ferma pertanto a questo punto.
  È previsto che una copia di questo consenso venga salvata e che lei possa riceverla tramite e-mail.
  Accederà inoltre a un manuale che le spiegherà come procedere con il programma.
</div>
<br>
<hr>
<div mat-dialog-actions style="justify-content: center; margin-top: 30px">
  <ng-container *ngIf="data.localeCompare('PAZIENTE') === 0">
    <button mat-raised-button color="warn" [mat-dialog-close]="!accepted">Non acconsento</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="accepted">Acconsento</button>
  </ng-container>
</div>
